import React, { useRef } from 'react';
import { Formik, Field } from 'formik';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';

import useFormRutine from '../../../../../hooks/useForm';
import { InputField } from '../../../../../components/formFields/InputField';
import * as Yup from 'yup';
import { EDIT_TYPES } from '../../constants';

type ClassificationFormProps = {
  formProps?: any;
  submitOutside?: boolean;
  submit: (values: any) => void;
  error?: any;
  type?: string | null;
  data?: any[];
};

const ClassificationForm = ({
  formProps = {},
  submitOutside,
  submit,
  error,
  type,
}: ClassificationFormProps) => {
  const formRef = useRef<any>();

  useFormRutine(formRef, submitOutside, null, null, null, error);

  const init = (props: any) => {
    if (props) {
      return {
        title: props?.title,
        is_def_component: props?.is_def_component ? 1 : 2,
        is_def_composition: props?.is_def_composition ? 1 : 2,
      };
    }
    return {
      title: null,
      is_def_component: null,
      is_def_composition: null,
    };
  };

  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
    is_def_component: Yup.number().nullable().required('Povinné pole'),
    is_def_composition: Yup.number().nullable().required('Povinné pole'),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        validationSchema={ValidationSchema}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(values);
        }}
      >
        {({ values }) => {
          return (
            <div className="space-y-1">
              {(type === EDIT_TYPES.translations || type === null) && (
                <Field
                  name="title"
                  value={values.title || null}
                  component={InputField}
                  label="Název"
                  data-testid="classification-form-title-input"
                />
              )}
              {(type === EDIT_TYPES.detail || type === null) && (
                <>
                  <SelectFormField
                    name="is_def_component"
                    label="Definuje komponentu"
                    data={[
                      { id: 1, title: 'Ano' },
                      { id: 2, title: 'Ne' },
                    ]}
                    data-testid="classification-form-component-select"
                  />
                  <SelectFormField
                    name="is_def_composition"
                    label="Definuje skladbu"
                    data={[
                      { id: 1, title: 'Ano' },
                      { id: 2, title: 'Ne' },
                    ]}
                    data-testid="classification-form-composition-select"
                  />
                </>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ClassificationForm;
